const ConversionRateActionTypes = {
    SET_CONVERSION_RATE: 'SET_CONVERSION_RATE',
  };

  export default ConversionRateActionTypes;